import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/shared/components/ui/dialog'
import { Button } from 'src/shared/components/ui/button'
import { useLocalization } from 'src/shared/hooks/useLocalization'

interface DeleteCategoryDialogProps {
  open: boolean
  categoryName: string
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export const DeleteCategoryDialog = ({
  open,
  categoryName,
  onOpenChange,
  onConfirm,
}: DeleteCategoryDialogProps) => {
  const { t } = useLocalization()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t('Delete category', 'Radera kategori')}</DialogTitle>

          <DialogDescription className="mt-2">
            {t(
              'Are you sure you want to delete',
              'Är du säker på att du vill radera'
            )}{' '}
            "{categoryName}"?{' '}
            {t(
              'This action cannot be undone.',
              'Denna åtgärd kan inte ångras.'
            )}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>
            {t('Cancel', 'Avbryt')}
          </Button>

          <Button variant="destructive" onClick={onConfirm}>
            {t('Delete', 'Radera')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
